:host {
	max-width: min(calc(100% - 2rem), 56rem);
	margin: auto;
	display: flex;
	flex-direction: column;
	gap: 2em;
	margin-top: 2em;
}

:host>smoothly-theme-picker {
	width: 20em;
}

:host>div {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 1rem;
}
